import NearPlacesSection from "./nearPlacesSection";

export default NearPlacesSection;
